module.exports = __webpack_public_path__ + "media/newstyle/images/book-1-5fdf309434662932e6ccd5188a1adce3.png";